import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { PrFeatureShellCommonModule } from '../pr-feature-shell-common.module';
import { SpecTableComponent } from './components/spec-table/spec-table.component';
import { ModelComparisonComponent } from './model-comparison.component';
import { ModelComparisonContainerComponent } from './model-comparison.container';

@NgModule({
  declarations: [
    ModelComparisonContainerComponent,
    ModelComparisonComponent,
    SpecTableComponent,
  ],
  imports: [
    CommonModule,
    PrFeatureShellCommonModule,
    DgxComponentsIconModule,
    DgxComponentsButtonModule,
    FormsModule,
  ],
})
export class ModelComparisonModule {}
